<template>
    <sweet-modal ref="modalSalvarCarteira" title="Salve sua carteira" blocking>
        <form action="#" @submit.prevent="submitFormLogin" data-vv-scope="formulario">
            <div class="form-group" @keydown="$event.key === '-' ? $event.preventDefault() : null"><!-- Nome -->
                <label class="form-label" for="nome">Nome</label>
                <input type="text" v-model="formularioSalvar.nome.value"
                    class="form-control" :class="{'is-invalid': errors.has('formulario.nome')}" 
                    name="nome" key="nome" maxlength="50" />
                <span v-show="errors.has('formulario.nome')" class="invalid-feedback">{{ errors.first('formulario.nome') }}</span>
            </div>
            <div class="form-group" @keydown="$event.key === '-' ? $event.preventDefault() : null"><!-- Email -->
                <label class="form-label" for="email">Email</label>
                <input type="text" v-model="formularioSalvar.email.value" v-validate="'required|email'" 
                    class="form-control" :class="{'is-invalid': errors.has('formulario.email')}" 
                    name="email" key="email" maxlength="50" />
                <span v-show="errors.has('formulario.email')" class="invalid-feedback">{{ errors.first('formulario.email') }}</span>
            </div>
            <div class="form-group" @keydown="$event.key === '-' ? $event.preventDefault() : null"><!-- Telefone -->
                <label class="form-label" for="telefone">Telefone</label>
                <input type="text" v-model="formularioSalvar.telefone.value" v-validate="'required|telefone'" 
                    class="form-control" :class="{'is-invalid': errors.has('formulario.telefone')}" 
                    name="telefone" key="telefone" maxlength="50" />
                <span v-show="errors.has('formulario.telefone')" class="invalid-feedback">{{ errors.first('formulario.telefone') }}</span>
            </div>
            <div class="form-group" @keydown="$event.key === '-' ? $event.preventDefault() : null"><!-- Senha -->
                <label class="form-label" for="senha">Senha</label>
                <input type="password" v-model="formularioSalvar.senha.value" v-validate="'required'" 
                    class="form-control" :class="{'is-invalid': errors.has('formulario.senha')}" 
                    name="senha" key="senha" maxlength="50" />
                <span v-show="errors.has('formulario.senha')" class="invalid-feedback">{{ errors.first('formulario.senha') }}</span>
            </div>
            <div class="d-flex flex-row justify-content-between mt-4">
                <button class="btn btn-custom tertiary text-custom secondary" type="button" @click="$refs.modalSalvarCarteira.close()">Cancelar</button>
                <button class="btn btn-custom primary" type="submit" :disabled="!formValid">Salvar</button>
            </div>
        </form>
    </sweet-modal>
</template>

<script>
import Vue from "vue"
import SimuladorService from "@/app/services/Simulador/simulador.service";
import SpinnerService from '../../services/spinner.service';
import moment from 'moment';

export default {
    computed: {
        formValid() {
            return this.errors.items.length == 0
                && this.formularioSalvar.email.value
                && this.formularioSalvar.senha.value
                && this.formularioSalvar.nome.value
                && this.formularioSalvar.telefone.value;
        }
    },
    data() {
        return {
            formularioSalvar: {
                email: {
                    value: ''
                },
                senha: {
                    value: ''
                },
                telefone: {
                    value: ''
                },
                nome: {
                    value: ''
                },
            }
        }
    },
    methods: {
        abrir() {
            this.formularioSalvar.email.value = "";
            this.formularioSalvar.senha.value = "";
            this.formularioSalvar.nome.value = "";
            this.formularioSalvar.telefone.value = "";

            // Resetar veevalidate
            this.$nextTick(() => {
                this.errors.clear();
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            });

           this.$refs['modalSalvarCarteira'].open();
        },
        submitFormLogin(scope) {
            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                    SimuladorService.salvarCarteira({
                        token: this.$route.query.token,
                        email: this.formularioSalvar.email.value,
                        senha: this.formularioSalvar.senha.value,
                        nome:  this.formularioSalvar.nome.value,
                        telefone: this.formularioSalvar.telefone.value
                    }).then((retorno) => {
                        
                        if (retorno.sucesso) {
                            Vue.notify({
								title: 'Sucesso',
								type: "success",
								group: 'principal',
								text: "Carteira salva com sucesso.",
                                duration: 5000
                            });

                            this.$router.push({ path: 'principal', query: { token: this.$route.query.token }})
                            this.$emit('acaoRealizada', { tipo: "carteiraSalva" });
                            this.$store.commit("setEmailSalvo", this.formularioSalvar.email.value);
                            this.$store.commit("setCarteiraAtualSalva", true);
                            this.$store.commit("setLogado", true);
                            this.$refs.modalSalvarCarteira.close();
                            this.$emit('acaoRealizada', { tipo: "loginRealizado" });
                        } else {
                            Vue.notify({
                                title: 'Falha',
                                type: "error",
                                group: 'principal',
                                text: retorno.mensagem,
                                duration: 5000
                            });
                        }
                    });
                }
            });
        }
    }
}
</script>